export default (): void => {
  const passwordWrapper = document.querySelector(".password-field-wrapper");
  const passwordField = passwordWrapper?.querySelector("input");
  const toggleButton = passwordWrapper?.querySelector(".toggle-pw");
  if (passwordWrapper && passwordField && toggleButton) {
    toggleButton.addEventListener("click", () => {
      const isObfuscated = passwordField.getAttribute("type") === "password";
      passwordField.setAttribute("type", isObfuscated ? "text" : "password");
      toggleButton.setAttribute(
        "aria-label",
        toggleButton.getAttribute(
          `data-aria-label-${isObfuscated ? "hide" : "show"}`
        ) as string
      );
    });
  }
};
